import FunctionalityImage1Desktop from '@/assets/images/digital-wallet/functionality-1-desktop.png'
import FunctionalityImage1 from '@/assets/images/digital-wallet/functionality-1.png'
import FunctionalityImage2Desktop from '@/assets/images/digital-wallet/functionality-2-desktop.png'
import FunctionalityImage2 from '@/assets/images/digital-wallet/functionality-2.png'
import FunctionalityImage3Desktop from '@/assets/images/digital-wallet/functionality-3-desktop.png'
import FunctionalityImage3 from '@/assets/images/digital-wallet/functionality-3.png'

export const SLIDES = [
  {
    title: 'functionality.slides.slide1.title',
    content: [
      'functionality.slides.slide1.content1',
      'functionality.slides.slide1.content2',
      'functionality.slides.slide1.content3',
      'functionality.slides.slide1.content4'
    ],
    image: FunctionalityImage1,
    imageDesktop: FunctionalityImage1Desktop
  },
  {
    title: 'functionality.slides.slide2.title',
    content: [
      'functionality.slides.slide2.content1',
      'functionality.slides.slide2.content2',
      'functionality.slides.slide2.content3'
    ],
    image: FunctionalityImage2,
    imageDesktop: FunctionalityImage2Desktop
  },
  {
    title: 'functionality.slides.slide3.title',
    content: [
      'functionality.slides.slide3.content1',
      'functionality.slides.slide3.content2'
    ],
    image: FunctionalityImage3,
    imageDesktop: FunctionalityImage3Desktop
  }
]
